<mic-spinner-overlay ariaLabel="loading" color="primary" [loading]="isLoadingData || isSavingData">
  <!-- Page Header -->
  <h1>{{ 'fleet.title' | translate }}</h1>
  <p id="description1">{{ 'fleet.description1' | translate }}</p>
  <!-- Tab Content -->
  <mat-card class="card-content">
    <mat-card-content>
      <tkc-modification-buttons class="buttons-header"
                                [isModificationsPending]="isModificationsPending"
                                [saveModifications]="saveModifications.bind(this)"
                                [resetModifications]="resetModifications.bind(this)">
        <button mat-flat-button color="accent" extra-button (click)="onConfirmSaveAndRecalculate()" [disabled]="!isModificationsPending">
          <mat-icon>save</mat-icon>
          {{ 'sites.seasonality.saveAndRecalculate' | translate }}
        </button>
      </tkc-modification-buttons>
      <div class="card-side-padding">
        <app-autocomplete
          [placeholder]="'fleet.card.header.row1.filter.modelName' | translate"
          [label]="('fleet.card.header.row1.filter.modelName' | translate)"
          [filterCtrl]="modelFilterCtrl"
          [filteredList$]="filteredModels$"
          [isLoading]="isModelsLoading"
          [displayKey]="'specification'"
          (elementSelected)="onElementSelected($event)"
          (searchChanged)="onSearchChanged($event)" />
        <div class="table-header-and-footer-container">
          <div id="table-selection-buttons" class="first-block">
            <div [ngClass]="selectedTable === 'quantities' ? 'selected-button' : ''" class="button-wrapper">
              <button id="quantities" mat-flat-button color="primary"
                      class="mic-btn-icon-left"
                      (click)="switchTable('quantities')"
                      [ngClass]="getQtyActiveClass()">
                <mat-icon>local_shipping</mat-icon>
                <span>{{ 'fleet.card.header.row2.quantities' | translate }}</span>
              </button>
            </div>
            <div [ngClass]="selectedTable === 'hours' ? 'selected-button' : ''" class="button-wrapper">
              <button id="hours" mat-flat-button color="primary"
                      class="mic-btn-icon-left"
                      (click)="switchTable('hours')"
                      [ngClass]="getHoursActiveClass()">
                <mat-icon>calendar_clock</mat-icon>
                <span>{{ 'fleet.card.header.row2.hours' | translate }}</span>
              </button>
            </div>
          </div>
          <div class="second-block">
            <mic-year-scroller [(year)]="currentYear" />
          </div>
          <div class="third-block">
            <button mat-flat-button class="mic-btn-icon-left button-add" (click)="openAddNewFleetModal()">
              <span>{{ 'fleet.card.footer.addNewFleet' | translate }}</span>
              <mat-icon>add_2</mat-icon>
            </button>
          </div>
        </div>
      </div>
      <div id="tab-content-card-table">
        @if (selectedTable === 'quantities') {
          <mic-fleet-quantity-table [(year)]="currentYear"
                                    [truckModel]="truckModel"
                                    [(isModificationsPending)]="isModificationsPending"
                                    [(isLoadingData)]="isLoadingData"
                                    [(isSavingData)]="isSavingData"
                                    (dataLoaded)="onTableDataLoaded()" />
        } @else if (selectedTable === 'hours') {
          <mic-fleet-hour-table [(year)]="currentYear"
                                [truckModel]="truckModel"
                                [(isModificationsPending)]="isModificationsPending"
                                [(isLoadingData)]="isLoadingData"
                                [(isSavingData)]="isSavingData"
                                (dataLoaded)="onTableDataLoaded()" />
        }
      </div>
      <div class="table-header-and-footer-container">
        <div class="first-block">
        </div>
        <div class="second-block">
          <mic-year-scroller [(year)]="currentYear" />
        </div>
        <div class="third-block">
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</mic-spinner-overlay>
